/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M5.25 5.75a.75.75 0 0 0 0 1.5h8.25a.75.75 0 0 0 0-1.5H5.25ZM4.5 11a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 0 1.5H5.25A.75.75 0 0 1 4.5 11Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.25 9.337V3.75C18.25 1.679 16.5711 0 14.5 0H4.25C2.179 0 .5 1.679.5 3.75v14c0 2.0711 1.679 3.75 3.75 3.75h7.5408c.5933 1.4659 2.0305 2.5 3.7092 2.5h4c2.2091 0 4-1.7909 4-4v-4c0-1.1046-.8954-2-2-2h-.75v-1.5c0-1.5368-1.0667-2.8245-2.5-3.163Zm-1.5-5.587c0-1.2426-1.0074-2.25-2.25-2.25H4.25C3.0074 1.5 2 2.5074 2 3.75v14C2 18.9926 3.0074 20 4.25 20h7.25v-4c0-1.1046.8954-2 2-2h.75v-1.5c0-1.5368 1.0667-2.8245 2.5-3.163V3.75ZM19.25 14v-1.5c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75V14h3.5Zm-1 4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuConfigsSecretsFilled'
);
